import { normalize } from "@/lib/utils";

/**
 * Üye kaydındaki telefon alanı tek metin: satır başına "numara - etiket",
 * araya e-posta da girebiliyor. Etiket çoğu zaman kişinin adı, bazen
 * "MUHASEBE". Buradan aranabilir numaraları ayıklarız.
 *
 * Numara 10 haneye indirilir (başındaki 0 ve 90 atılır); 5 ile başlayan cep
 * numarasıdır ve WhatsApp'a yalnız o gönderilir.
 */
export function telefonlar(phone) {
  const sonuc = [];
  const gorulen = new Set();
  for (const satir of String(phone || "").split(/\r?\n|;/)) {
    if (!satir.trim() || satir.includes("@")) continue;
    const [numaraKismi, ...etiketParca] = satir.split(" - ");
    let d = numaraKismi.replace(/\D/g, "");
    if (d.startsWith("90") && d.length >= 12) d = d.slice(2);
    if (d.startsWith("0")) d = d.slice(1);
    if (d.length < 10) continue;
    d = d.slice(0, 10);
    if (gorulen.has(d)) continue;
    gorulen.add(d);
    sonuc.push({ numara: d, etiket: etiketParca.join(" - ").trim(), cep: d.startsWith("5") });
  }
  return sonuc;
}

/**
 * Üyenin kendi cep numarası: etiketi üyenin adıyla eşleşen cep, yoksa
 * muhasebe olmayan ilk cep, o da yoksa ilk cep.
 */
export function birincilCep(uye) {
  const cepler = telefonlar(uye?.phone).filter((t) => t.cep);
  if (cepler.length === 0) return null;
  const ad = normalize(uye?.name).split(" ").filter(Boolean);
  if (ad.length > 0) {
    const ilk = ad[0];
    const son = ad[ad.length - 1];
    const eslesen = cepler.find((t) => {
      const e = normalize(t.etiket);
      return e && e.includes(ilk) && e.includes(son);
    });
    if (eslesen) return eslesen;
  }
  return cepler.find((t) => !normalize(t.etiket).includes("muhasebe")) || cepler[0];
}

/** 5321234567 → 0532 123 45 67 */
export const numaraYaz = (d) =>
  d && d.length === 10 ? `0${d.slice(0, 3)} ${d.slice(3, 6)} ${d.slice(6, 8)} ${d.slice(8)}` : d || "";

export const telLinki = (d) => `tel:+90${d}`;

/** wa.me hem WhatsApp'ı hem WhatsApp Business'ı açar; rehbere kayıt gerekmez. */
export const waLinki = (d, metin = "") =>
  `https://wa.me/90${d}${metin ? `?text=${encodeURIComponent(metin)}` : ""}`;

/** "AHMET YILMAZ" → "Ahmet Yılmaz" (Türkçe i/ı kurallarıyla). */
export const basHarfBuyuk = (s) =>
  String(s || "")
    .toLocaleLowerCase("tr-TR")
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toLocaleUpperCase("tr-TR") + w.slice(1))
    .join(" ");

const vcfKacis = (s) =>
  String(s || "")
    .replace(/\\/g, "\\\\")
    .replace(/,/g, "\\,")
    .replace(/;/g, "\\;")
    .replace(/\r?\n/g, "\\n");

/**
 * Seçilen üyeleri tek .vcf dosyasında rehber kartı olarak verir. Ad önüne
 * komite kısaltması eklenir; rehberde hepsi bir arada durur, sonra kolayca
 * bulunup silinir.
 */
export function vcardMetni(uyeler, onEk) {
  const kartlar = [];
  for (const u of uyeler) {
    const cepler = telefonlar(u.phone).filter((t) => t.cep);
    if (cepler.length === 0) continue;
    const birincil = birincilCep(u);
    const sirali = [birincil, ...cepler.filter((t) => t.numara !== birincil.numara)];
    const ad = `${onEk} ${basHarfBuyuk(u.name)}`.trim();
    const satirlar = [
      "BEGIN:VCARD",
      "VERSION:3.0",
      `N:;${vcfKacis(ad)};;;`,
      `FN:${vcfKacis(ad)}`,
    ];
    if (u.company) satirlar.push(`ORG:${vcfKacis(u.company)}`);
    sirali.forEach((t, i) =>
      satirlar.push(`TEL;TYPE=CELL${i === 0 ? ",PREF" : ""}:+90${t.numara}`)
    );
    satirlar.push("END:VCARD");
    kartlar.push(satirlar.join("\r\n"));
  }
  return kartlar.join("\r\n") + "\r\n";
}
